import 'react-phone-number-input/style.css'
import PhoneInputLib from 'react-phone-number-input'
import type { Country } from 'react-phone-number-input'

interface PhoneInputProps {
  label?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  required?: boolean
  defaultCountry?: Country
}

export default function PhoneInput({
  label,
  value,
  onChange,
  placeholder = 'Phone number',
  required,
  defaultCountry = 'IN',
}: PhoneInputProps) {
  return (
    <div className="phone-input-wrapper">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <PhoneInputLib
        international
        countryCallingCodeEditable={false}
        defaultCountry={defaultCountry}
        value={value || ''}
        onChange={(val) => onChange(val || '')}
        placeholder={placeholder}
        className="phone-input-field"
        required={required}
      />
      <style>{`
        .phone-input-wrapper .PhoneInput {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        .phone-input-wrapper .PhoneInputCountry {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          padding: 0.5rem 0.5rem 0.5rem 0.75rem;
          border: 1px solid #d1d5db;
          border-radius: 0.5rem 0 0 0.5rem;
          background: #f9fafb;
          cursor: pointer;
          border-right: none;
        }
        .phone-input-wrapper .PhoneInputCountryIcon {
          width: 1.25rem;
          height: 0.9rem;
        }
        .phone-input-wrapper .PhoneInputCountryIcon--border {
          box-shadow: none;
          background: none;
        }
        .phone-input-wrapper .PhoneInputCountrySelectArrow {
          width: 0.4rem;
          height: 0.4rem;
          border-color: #9ca3af;
          opacity: 0.7;
          margin-left: 0.25rem;
        }
        .phone-input-wrapper .PhoneInputInput {
          flex: 1;
          padding: 0.5rem 0.75rem;
          border: 1px solid #d1d5db;
          border-radius: 0 0.5rem 0.5rem 0;
          font-size: 0.875rem;
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .phone-input-wrapper .PhoneInputInput:focus {
          border-color: #6366f1;
          box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
        }
        .phone-input-wrapper .PhoneInputCountrySelect {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          opacity: 0;
          cursor: pointer;
          z-index: 1;
        }
      `}</style>
    </div>
  )
}
